import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  isLoggedIn: boolean = false;

  constructor(private readonly storage: LocalStorageService, private readonly router: Router) {
  }

  ngOnInit() {
    this.isLoggedIn = this.storage.retrieve('isloggedin');
    if (this.isLoggedIn) {
      this.isLoggedIn = true;
    }
    else {
      this.router.navigate(['/login']);
    }
  }

  ngDoCheck() {
    this.isLoggedIn = this.storage.retrieve('isloggedin');
  }
}
